import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'leadgen.title',
    defaultMessage: 'Find the best studios near you.',
  },
  subtitle: {
    id: 'leadgen.subtitle',
    defaultMessage: 'Join the waitlist and be one of the first ones to know when we’re ready for launch.',
  },
});
